import React from 'react';
class Title extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      URL: ''
    };
  }

  updateTitle(event) {
    this.setState({
      title: event.target.value
    });
  }

  updateURL(event) {
    this.setState({
      URL: event.target.value
    });
  }

  render() {
    return(
      <div className = "embed-group embed-title">
        <div className = "embed-title-text">
          <input
            type = "text"
            name = "title"
            placeholder = "Title"
            maxLength="256"
            value = {this.state.title}
            onChange = {event => this.updateTitle(event)}
          />
        </div>
        <div className="embed-title-url">
          <input
            type="url"
            name="url"
            placeholder="URL"
            value = {this.state.URL}
            onChange = {event => this.updateURL(event)}
          />
        </div>
      </div>
    );
  }
}

export default Title;
